export default "__VITE_ASSET__d5d31215__"